import { Link, useLocation } from "react-router-dom"
import "../views/LegalPages.css"

export default function LegalLayout({ children }) {
  const location = useLocation()

  return (
    <main className="legal-page">
      <div className="legal-container">

        <header className="legal-header">
          <h1>Informations légales</h1>

          <p>
            Ensemble des documents légaux relatifs à l'utilisation du site
            de la Friterie de Lalaing.
          </p>

          <nav className="legal-nav">
            <Link
              className={location.pathname === "/mentions-legales" ? "active" : ""}
              to="/mentions-legales"
            >
              Mentions légales
            </Link>

            <Link
              className={location.pathname === "/confidentialite" ? "active" : ""}
              to="/confidentialite"
            >
              Confidentialité
            </Link>

            <Link
              className={location.pathname === "/conditions" ? "active" : ""}
              to="/conditions"
            >
              Conditions
            </Link>
          </nav>
        </header>

        <section className="legal-content">
          {children}
        </section>

        <footer className="legal-footer">
          <p>
            Dernière mise à jour : juillet 2026
          </p>
        </footer>

      </div>
    </main>
  )
}